import { createContext, useEffect, useState } from "react"
import { node } from "prop-types"
import { useDebounce } from "use-debounce"
import {
  useTranslatedQueryParamsState,
  OPEN_GROUPS_ENROLLMENT_STATUS,
  ALL_GROUPS_ENROLLMENT_STATUS,
} from "../hooks/useTranslatedQueryParamsState"
import { useGroupType } from "../hooks/useGroupType"
import useFilters from "../hooks/useFilters"
export const FiltersContext = createContext()

export function FiltersContextProvider({ children }) {
  const { data: groupType } = useGroupType()
  const closedAndFullGroupsVisible =
    groupType.attributes.closed_and_full_groups_visible
  const [params, updateParams] = useTranslatedQueryParamsState()
  const [searchTerm, setSearchTerm] = useState(params["where[name]"] || "")
  const [debouncedSearchTerm] = useDebounce(searchTerm, 300)
  const [campusIds, setCampusIds] = useState(params.campus_id?.split(",") || [])
  const [tagIds, setTagIds] = useState(params.tag_id?.split(",") || [])
  const [includeClosedGroups, setIncludeClosedGroups] = useState(
    closedAndFullGroupsVisible || params.enrollment?.includes("closed"),
  )

  useFilters("campus", campusIds, updateParams)
  useFilters("tag", tagIds, updateParams)

  useEffect(() => {
    updateParams((prev) => ({
      ...prev,
      enrollment: includeClosedGroups
        ? ALL_GROUPS_ENROLLMENT_STATUS
        : OPEN_GROUPS_ENROLLMENT_STATUS,
    }))
  }, [includeClosedGroups, updateParams])

  useEffect(() => {
    updateParams((prev) => ({ ...prev, "where[name]": debouncedSearchTerm }))
  }, [debouncedSearchTerm, updateParams])

  const clearFilters = () => {
    setSearchTerm("")
    setIncludeClosedGroups(false)
    setTagIds([])
    setCampusIds([])
  }

  return (
    <FiltersContext.Provider
      value={{
        clearFilters,
        searchTerm,
        setSearchTerm,
        params,
        updateParams,
        includeClosedGroups,
        setIncludeClosedGroups,
        tagIds,
        setTagIds,
        campusIds,
        setCampusIds,
      }}
    >
      {children}
    </FiltersContext.Provider>
  )
}
FiltersContextProvider.propTypes = {
  children: node.isRequired,
}
